import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import RgLogo from '@/assets/icons/rgLogo';
import { ButtonMore } from '@/components/ButtonMore';
import { LineSeparator } from '@/components/LineSeparator';
import { SizedBox } from '@/components/SizedBox';
import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { getUrlFromLinks } from '@/feature/invite-friends/utils/utils';
import { useJurisdictionStore } from '@/hooks/use-jurisdiction';
import { ProductDocumentDataBodyScreenLinksSliceItem } from '@/types/prismic.generated';

const EMPTY: ProductDocumentDataBodyScreenLinksSliceItem[] = [];

export const GambleResponsibly = () => {
    const { t } = useTranslation('raf');
    const navigation = useNavigation();
    const links = useJurisdictionStore(state => state.jurisdictionSettings?.productConfig?.screenLinks) ?? EMPTY;
    const termsAndConditionsLink = getUrlFromLinks({ links, linkType: 'TermsAndConditions' });
    const privacyPolicyLink = getUrlFromLinks({ links, linkType: 'PrivacyPolicy' });
    const houseRulesLink = getUrlFromLinks({ links, linkType: 'HouseRules' });

    const handlePress = (link: string) => {
        navigation.navigate('ModalWebView', { uri: link });
    };

    return (
        <>
            <Box
                pt={'s32'}
                paddingHorizontal={'s16'}
                backgroundColor={ds.colorToken.background.neutral.subtler}
                style={styles.border}
                borderRadius={'r16'}
                borderWidth={1}
            >
                <Box alignItems={'center'} paddingHorizontal={'s16'}>
                    <RgLogo />
                    <SizedBox value={16} />
                    <Text color={ds.colorToken.text.primary} variant="titleLarge">
                        {t('gamble_responsibly_title')}
                    </Text>
                    <SizedBox value={4} />
                    <Text
                        variant="bodySmall"
                        textAlign={'center'}
                        color={ds.colorToken.text.secondary}
                        paddingHorizontal={'s20'}
                    >
                        {t('gamble_responsibly_description')}
                    </Text>
                </Box>
                <SizedBox value={24} />
                <ButtonMore
                    style={styles.noSeparator}
                    label={t('terms_and_conditions')}
                    onPress={() => {
                        if (termsAndConditionsLink) {
                            handlePress(termsAndConditionsLink);
                        }
                    }}
                />
                <LineSeparator />
                <ButtonMore
                    style={styles.noSeparator}
                    label={t('house_rules')}
                    onPress={() => {
                        if (houseRulesLink) {
                            handlePress(houseRulesLink);
                        }
                    }}
                />
                <LineSeparator />
                <ButtonMore
                    style={styles.noSeparator}
                    label={t('privacy_policy')}
                    onPress={() => {
                        if (privacyPolicyLink) {
                            handlePress(privacyPolicyLink);
                        }
                    }}
                />
            </Box>
            <SizedBox value={24} />
        </>
    );
};

const styles = StyleSheet.create({
    border: {
        borderColor: ds.colorValue.border.subtle,
    },
    noSeparator: {
        borderBottomWidth: 0,
    },
});
